<template>
    <div class="shareShopIconMain" ref="shareShopIcon" :style="`opacity: ${ keepPress ? 1 : 0.6 }`">
        <img
            :src="`${getShopFoodMarketHostUrl()}static/images/product/share.png`"
            style="width:100%;height:100%;"
        />
    </div>
</template>

<script>
export default {
    name: 'SharedIcon',

    data() {
        return {
            keepPress: false,
        }
    },

    mounted() {
        //
        this.$refs.shareShopIcon.addEventListener(
            'touchstart',
            (e) => {
                //
                e.stopPropagation()

                //
                this.start(e)
            },
            {
                capture: true,
            }
        )

        this.$refs.shareShopIcon.addEventListener(
            'touchend',
            (e) => {
                //
                e.stopPropagation()

                //
                this.end(e)
            },
            {
                capture: true,
            }
        )

        this.$refs.shareShopIcon.addEventListener(
            'touchmove',
            (e) => {
                //
                e.stopPropagation()
                e.preventDefault()

                //
                this.move(e)
            },
            {
                capture: true,
            }
        )
    },

    methods: {
        start() {
            this.keepPress = false

            //
            this.keepPressTimeout = setTimeout(() => {
                this.keepPress = true
            }, 100)
        },

        end() {
            //
            clearTimeout(this.keepPressTimeout)

            // keepPress
            this.keepPress = false;

            //
            if(this.$refs.shareShopIcon.getClientRects()[0].left + 20 < window.screen.width / 2)
            {
                this.$refs.shareShopIcon.style.transition = 'left 0.5s';
                this.$refs.shareShopIcon.style.left = '0px';
            }
            else
            {
                this.$refs.shareShopIcon.style.transition = 'left 0.5s';
                this.$refs.shareShopIcon.style.left = `${window.screen.width - 40}px`;
            }

            setTimeout(() => {
                this.$refs.shareShopIcon.style.transition = 'none'
            }, 550);
        },

        move(e) {
            if(this.keepPress == false)
            {
                return;
            }

            //
            let top = e.changedTouches[0].pageY - 20
            let left = e.changedTouches[0].pageX - 20

            //
            if(top < 0)
            {
                top = 0;
            }
            if(top > window.screen.height - 40)
            {
                top = window.screen.height - 40;
            }

            //
            if(left < 0)
            {
                left = 0;
            }
            if(left > window.screen.width - 40)
            {
                left = window.screen.width - 40;
            }

            //
            this.$refs.shareShopIcon.style.top = top + "px"
            this.$refs.shareShopIcon.style.left = left + "px"
        },
    },
}
</script>

<style lang="scss" scoped>

.shareShopIconMain {
    position: fixed;
    z-index: 101;
    width: 40px; 
    height: 40px;
    right: 0;
    opacity: 0.6;
    font-size: $fontSizeContent;
}

</style>